import { Inject } from '@odinjs/odin';

import { Endpoint, FormViewService, ProviderAccreditationPendenciesService, ToastServiceProviderAccreditation } from '@philips-emr/hpms-provider-accreditation-commons';
import { DynamicFieldsAPI, FetchAPI, FormAPI, Metadata, PanelAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnMount, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, msg } from '@philips-emr/tws-core/lib/services';
import { isEmptyArrayOrObject } from '@philips-emr/tws-utils';

import BaseController from '../BaseController';

import { AccreditationSteps } from './provider-accreditation-controller';

interface DynamicFieldsData {
  id: string | number;
  title: string;
}

@Controller({ fragment: 'provider-accreditation-questionnaire' })
export default class ProviderAccreditationQuestionnaireController extends BaseController {

  @Inject('form-questionnaire')
  private formQuestionnaire: FormAPI;

  @Inject('dynamic-fields-questionnaire')
  private dynamicFields: DynamicFieldsAPI;

  @Inject('fetch-questionnaire')
  private fetchQuestionnaire: FetchAPI;

  @Inject('panel-pendencies')
  private panelPendencies: PanelAPI;

  @Inject('toast-notification')
  private toast: ToastNotificationAPI;

  @OnMount('form-questionnaire')
  OnMountForm(event: MountEvent): void {
    const api = event.target as FormAPI;
    FormViewService.shouldEditForm(api, AccreditationSteps.QUESTIONNAIRE);
  }

  @OnSubmit('form-questionnaire')
  public onSubmitForm(event: FormAPI): void {
    const { record } = event;
    const { nrSeqUser, nrSeqAccreditation, nrSeqTypeAccreditation } = this.historyService.getCurrentRouteParams();
    const dynamicFieldsData = this.dynamicFields.getMetadata() as DynamicFieldsData;

    const body = {
      nrSeqTypeAccreditation,
      wModeloSubmitDTO: {
        formSubmit: record,
        dynamicFieldId: dynamicFieldsData.id,
      },
    };

    void HttpService.post(Endpoint.POST.QUESTIONNAIRE_METADATA, { nrSeqUser, nrSeqAccreditation }, { body })
      .then(() => {
        ToastServiceProviderAccreditation.success(msg('pa.questionnaire-answered'), '', 5000);
      })
      .catch(() => {
        ToastServiceProviderAccreditation.warning(msg('pa.questionnaire-error'), '', 5000);
      });
  }

  @OnMount('dynamic-fields-questionnaire')
  public async onMount(): Promise<void> {
    try {
      const { nrSeqUser, nrSeqAccreditation, nrSeqTypeAccreditation } = this.historyService.getCurrentRouteParams();
      const response = await HttpService.get(Endpoint.GET.QUESTIONNAIRE_METADATA, { nrSeqUser, nrSeqTypeAccreditation });

      this.dynamicFields.setMetadata(response.body as Metadata);
      this.formQuestionnaire.setTitle((response.body as DynamicFieldsData).title);

      this.context.set({ nrSeqUser, nrSeqAccreditation });
      this.fetchQuestionnaire.setEndpoint(Endpoint.GET.QUESTIONNAIRE_REPLEIS);
      this.fetchQuestionnaire.setParameters({ nrSeqUser, nrSeqAccreditation });

    } catch (error) {
      ToastServiceProviderAccreditation.warning(msg('pa.questionnaire-error'), '', 5000);
    }
  }

  @OnMount('fetch-pendencies')
  onMountFetchPendencies(event: MountEvent): void {
    ProviderAccreditationPendenciesService.fetchCardPendencies(event, AccreditationSteps.QUESTIONNAIRE);
  }

  @OnAfterFetch('fetch-pendencies')
  onAfterFetch(event: FetchEvent): void {
    if (isEmptyArrayOrObject(event.data)) {
      this.panelPendencies.setVisible(false);
    } else {
      ProviderAccreditationPendenciesService.setMessageToastPendency(this.toast, event);
    }
  }

}
